'use es6';

import { buildQueryString, parseQueryString } from '../utils/qs';
import { isLegacyLink, isPreferencesGroupLink, isTestPreferencesGroupLink } from './urlValidator';
import { prepareBrandData, prepareSubscriptionsData } from './earlyDataProcessor';
import makeEarlyRequest from './makeEarlyRequest';
const fetchLegacyLink = (startTime, {
  email,
  d,
  languagePreference,
  product,
  v,
  s
}) => {
  if (v === '5') {
    makeEarlyRequest({
      apiUrl: `/emailsubscriptions/v1/manage-preferences/starter-sales?${buildQueryString({
        v,
        s,
        d,
        email
      })}`,
      earlyRequestKey: 'getSubscriptions',
      startTime,
      callback: data => {
        prepareSubscriptionsData(email, data);
      }
    });
    makeEarlyRequest({
      apiUrl: `/subscriptions/v1/preferences/sales-portal-information?${buildQueryString({
        d,
        s,
        v
      })}`,
      earlyRequestKey: 'getBrandInformation',
      startTime,
      callback: data => prepareBrandData(data)
    });
  } else {
    makeEarlyRequest({
      apiUrl: `/emailsubscriptions/v1/manage-preferences/starter-definitions?${buildQueryString({
        d,
        product,
        email: product === 'sales' ? email : '',
        languagePreference
      })}`,
      earlyRequestKey: 'getSubscriptions',
      startTime,
      callback: data => {
        prepareSubscriptionsData(email, data);
      }
    });
    makeEarlyRequest({
      apiUrl: `/subscriptions/v1/preferences/portal-information?${buildQueryString({
        d,
        product
      })}`,
      earlyRequestKey: 'getBrandInformation',
      startTime,
      callback: data => prepareBrandData(data)
    });
  }
};
const fetchPreferencesGroupLink = ({
  d,
  languagePreference
}) => {
  const brandInfoQueryString = buildQueryString(Object.assign({
    d
  }, languagePreference ? {
    languagePreference
  } : {}));
  makeEarlyRequest({
    apiUrl: `/subscriptions/v1/preferences/render-information?${brandInfoQueryString}`,
    earlyRequestKey: 'getPreferencesInformation',
    callback: data => prepareBrandData(data.preferencesCompanyInfo)
  });
};
const fetchTestPreferencesGroupLink = ({
  d,
  groupId,
  languagePreference
}) => {
  const brandInfoQueryString = buildQueryString(Object.assign({
    d,
    groupId
  }, languagePreference ? {
    languagePreference
  } : {}));
  makeEarlyRequest({
    apiUrl: `/subscriptions/v1/preferences/render-information-test?${brandInfoQueryString}`,
    earlyRequestKey: 'getTestPreferencesInformation',
    callback: data => prepareBrandData(data.preferencesCompanyInfo)
  });
};
const fetchEmailUnsubscribe = ({
  search,
  startTime
}) => {
  const emailUnsubscribeQs = parseQueryString(search);
  if (isLegacyLink(emailUnsubscribeQs)) {
    fetchLegacyLink(startTime, emailUnsubscribeQs);
  } else if (isPreferencesGroupLink(emailUnsubscribeQs)) {
    if (isTestPreferencesGroupLink(emailUnsubscribeQs)) {
      fetchTestPreferencesGroupLink(emailUnsubscribeQs);
    } else {
      fetchPreferencesGroupLink(emailUnsubscribeQs);
    }
  }
};
export default fetchEmailUnsubscribe;